export default __webpack_public_path__ + "static/media/Website images-02.8666bc0d.jpg";